import React from "react";
import { flowRight as compose } from 'lodash';

import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import Shimmer from "./Shimmer";
import s from "../Home/PopularLocationGridItem/PopularLocationGridItem.css";
import l from './Skeleton.css';

const HomePopularSkeleton = () => {
  return (
    <div className={cx(s.GridCollapse, 'skeletonViewCard')}>
      <div className={s.noPadding}>
        <div className={cx(l.parentBgColor, s.GridWrap)}>
          <Shimmer />
        </div>
        <div className={cx(l.popularSkeletonContent)}>
          <Shimmer />
        </div>
      </div>
    </div>
  );
};

export default compose(
  withStyles(s, l),
)(HomePopularSkeleton);
